import { render, staticRenderFns } from "./PersonSmm.vue?vue&type=template&id=630d1f96&"
import script from "./PersonSmm.vue?vue&type=script&lang=js&"
export * from "./PersonSmm.vue?vue&type=script&lang=js&"
import style0 from "./PersonSmm.vue?vue&type=style&index=0&id=630d1f96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports